import type * as React from 'react'

import { FormattedMessage as IntlMessage, useIntl } from 'react-intl'

type FormattedMessageProps = Omit<
  React.ComponentProps<typeof IntlMessage>,
  'id' | 'defaultMessage'
> & {
  id: string
  defaultMessage?: string
  common?: boolean
}

// Export the component directly for new code
const FormattedMessage = ({
  id,
  defaultMessage,
  ...props
}: FormattedMessageProps) => (
  <IntlMessage id={id} defaultMessage={defaultMessage || id} {...props} />
)

export { useIntl }
export default FormattedMessage
